import React from 'react';
import { connect } from 'react-redux';
import Author from '../authors/authors';

const Authors = (props) => {
    return (
        <>
            <Author/>
        </>
    )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { })(Authors);